<template>
  <v-dialog
    v-model="createInvoiceDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('invoices.createInvoice') }}</b>
      </v-card-title>
      
      <v-card-text class="mt-10">
        <v-flex
          xs12
          mb-5
        >
          <v-autocomplete
            v-model.trim="form.user_uuid"
            :loading="loading"
            :search-input.sync="params.search"
            :items="whiteLabelUsers ? whiteLabelUsers.data : []"
            :item-text="'email'"
            :item-value="'uuid'"
            :error-messages="UserUuidErrors"
            :label="$t('globals.emailUser')+'*'"
            required
            @blur="$v.form.user_uuid.$touch()"
          >
            <template v-slot:no-data>
              <small class="ml-3">{{ $t('globals.noData') }}</small>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-layout
          v-for="i in itemsCount"
          :key="i"
          wrap
        >
          <v-flex xs7>
            <v-text-field
              v-model.trim="form.items[i-1].subject"
              maxlength="50"
              :label="$t('invoices.subject')"
            />
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model.trim="form.items[i-1].amount"
              class="ml-6"
              maxlength="12"
              :label="$t('invoices.amount')"
              suffix="USDT"
              @keypress="onlyForCurrency($event, form.items[i-1].amount)"
            />
          </v-flex>
          <v-flex
            v-if="itemsCount > 1 && i > 1"
            xs1
            pt-2
          >
            <v-icon
              class="ml-3 mt-2"
              style="cursor:pointer;"
              @click="removeItem(i-1)"
            >
              mdi-minus-circle-outline
            </v-icon>
          </v-flex>
        </v-layout>
        <v-flex
          v-if="itemsCount < 5 "
          mt-2
          mb-5
          xs12
        >
          <v-icon
            style="cursor:pointer;"
            @click="addMoreItems()"
          >
            mdi-plus-circle-outline
          </v-icon>
          <small
            style="cursor:pointer;"
            @click="addMoreItems()"
          >
            {{ $t('globals.addButton') }}
          </small>
        </v-flex>
        
        <v-text-field
          v-model.trim="form.fees"
          class="mt-10"
          maxlength="12"
          :label="$t('invoices.fees')"
          suffix="USDT"
          @keypress="onlyForCurrency($event, form.fees)"
        />
        <v-checkbox
          v-model="form.pay_to_affilliate"
          color="primary"
        >
          <template
            v-slot:label
          >
            <small>
              {{ $t('invoices.payToAffilliate') }}
            </small>
          </template>
        </v-checkbox>
      </v-card-text>
      <v-divider />
     
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="createInvoiceDialog = false"
        >
          <span>{{ $t('globals.cancelButton') }}</span>
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading || ($v.$invalid)"
          :loading="loading"
          @click="createInvoice()"
        >
          {{ $t('globals.createButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import WHITELABEL_USERS_QUERY from '@/graphql/queries/WhiteLabelUsersForInvoice.gql';
import CREATE_INVOICE_MUTATION from "@/graphql/mutations/CreateInvoice.gql";

const greaterThanZero = (value) => value > 0

import { validationMixin } from "vuelidate"
import { required, maxLength } from 'vuelidate/lib/validators';

export default {
  name: "CreateInvoiceDialog",
  mixins: [validationMixin],
  props: {
    whitelabelUuid: {
      type: String,
      default() {
        return null;
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemsCount: 1,
      loading: false,
      params: {
        search: "",
        whitelabel_uuid: this.whitelabelUuid,
        page: 1,
        count: 25
      },
      form: {
        user_uuid: null,
        pay_to_affilliate: false,
        fees: 0,
        items: [{subject: "", amount: 0}],
      }
    };
  },
  computed: {
    createInvoiceDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit('closeCreateInvoiceDialog', false);
      }
    },
    rules() {
      var form = {
        user_uuid: {
          required,
        },
        fees: {
          required,
        },
        items: {
          required,
          $each: {
            subject: {
              required,
              maxLength: maxLength(50)
            },
            amount: {
              required,
              greaterThanZero
            },
          }
        }
      };
      return form;
    },
    UserUuidErrors() {
      const errors = [];
      if (!this.$v.form.user_uuid.$dirty) return errors;
      !this.$v.form.user_uuid.required && errors.push(this.$t("projects.reqField"));
      return errors;
    },
  },
  watch: {
    params: {
      handler(val){
       
        if (val.search && val.search.length > 2) {
          this.$apollo.queries.whiteLabelUsers.refresh()
        }
      },
      deep: true
    }
  },
  validations() {
    return {
      form: this.rules
    };
  },
  methods: {
    addMoreItems() {
      this.form.items.push({subject: "", amount: 0})
      this.itemsCount++
    },
    removeItem(index) {
      this.form.items.splice(index, 1)
      this.itemsCount--
    },
    createInvoice() {
      this.form.items.forEach(element => {
        element.amount = parseFloat(element.amount)
      });
      this.form.fees = parseFloat(this.form.fees)
      this.$apollo
        .mutate({
          mutation: CREATE_INVOICE_MUTATION,
          variables: this.form
        })
        .then(data => {
          this.loading = false;
          this.createInvoiceDialog = false
          this.$parent.$apollo.queries.whiteLabelInvoices.refetch();
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
  apollo: {
    whiteLabelUsers: {
      query: WHITELABEL_USERS_QUERY,
      fetchPolicy: 'network-only',
      variables() {
        return this.params
      },
      skip() {
        return !this.whitelabelUuid || !this.params.search  || this.params.search.length < 2
      }
    },
  }
};
</script>

<style lang="scss" >
</style>
